import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIcomoonComponent } from './simple-icons-icomoon.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIcomoonComponent ],
    exports:      [ SimpleIconsIcomoonComponent ],
    bootstrap:    []
})
export class SimpleIconsIcomoonModule {}
